module.exports = __webpack_public_path__ + "static/media/reports_kyc_status.080f7948.svg";